
function RodoPolicy() {

    return (
        <>
            <p>
                Zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady Europy nr. 2016/679 z dnia 27 kwietnia 2016 roku w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych)
            </p>
            <h4>Klauzula Informacyjna RODO</h4>
            <p>
                Nadrzędnym celem klauzuli oraz działań informacyjnych Administratora Danych Osobowych jest zapewnienie adekwatnego poziomu ochrony uczestników konferencji, w związku z przetwarzaniem ich danych osobowych.
            </p>
            <p>
                <u>Administrator Danych Osobowych</u><br />
                Administratorem Pani/Pana danych osobowych jest <strong>Polskie Stowarzyszenie Rodzin z Atrezją Przełyku</strong> z siedzibą we Wrocławiu, ul. Piękna 60AB/17, 50-506 NIP: 8993002964, REGON: 529570950
            </p>
            <p>
                <strong>Dane kontaktowe Administratora Danych Osobowych:</strong><br />
                Email: <a href="mailto:kontakt@przelyczki.org.pl">kontakt@przelyczki.org.pl</a>
            </p>
            <p>
                <u>Inspektor Ochrony Danych</u><br />
                Administrator nie powołał Inspektora Danych Osobowych.
            </p>
            <p>
                <strong>RODO –</strong> Rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych).
            </p>
            <h4>Przetwarzanie danych osobowych</h4>
            <p>
                Zgodnie z treścią art. 4 ust. 2 RODO, za przetwarzanie danych osobowych należy rozumieć operację lub zestaw operacji wykonywanych na danych osobowych lub zestawach danych osobowych w sposób zautomatyzowany lub niezautomatyzowany, taką jak zbieranie, utrwalanie, organizowanie, porządkowanie, przechowywanie, adaptowanie lub modyfikowanie, pobieranie, przeglądanie, wykorzystywanie, ujawnianie poprzez przesłanie, rozpowszechnianie lub innego rodzaju udostępnianie, dopasowywanie lub łączenie, ograniczanie, usuwanie lub niszczenie.
            </p>
            <div>
                <p><u>Przetwarzanie danych</u></p>
                <ol>
                    <li>
                        <p>
                            Przetwarzanie Pani/Pana danych osobowych będzie się odbywać na podstawie art. 6 RODO i w celu kontaktu, przygotowania oferty oraz marketingowym.
                        </p>
                    </li>
                    <li>
                        <p>
                            Administrator powołuje się na prawnie uzasadniony interes, którym jest zbieranie danych statystycznych, analizowanie ruchu na stronie internetowej. Dokonywanie pomiarów, które pozwalają udoskonalać oferowane usługi i sprawić, że będą maksymalnie odpowiadać potrzebom.
                        </p>
                    </li>
                    <li>
                        <p>
                            Podanie danych osobowych na stronie internetowej <a href="https://konferencja.przelyczki.org.pl/">https://konferencja.przelyczki.org.pl/</a> jest dobrowolne. Podstawą przetwarzania danych jest Pana/Pani zgoda.
                            Mają Państwo wpływ na przeglądarkę internetową i jej ustawienia. Odbiorcami danych osobowych mogą być Google, Facebook, itp.
                            Mają Państwo prawo wycofania zgody w dowolnym momencie poprzez zmianę ustawień w przeglądarce.
                            Dane osobowe będą przetwarzane i przechowywane w zależności od okresu używania technologii.
                            Mają Państwo prawo zażądania od administratora dostępu do moich danych osobowych, ich sprostowania, usunięcia lub ograniczenia przetwarzania tych danych,
                            a także prawo wniesienia skargi do organu nadzorczego. Profilowanie używane jest w Google Analytics, Google AdWords, Facebook Pixel.
                            W sytuacji wniesienia sprzeciwu wobec profilowania, prosimy zoptymalizować odpowiednio przeglądarkę.
                        </p>
                    </li>
                    <li>
                        <p>
                            W przypadku pytań dotyczących przetwarzania danych osobowych prosimy o kontakt z Administratorem Danych Osobowych.
                        </p>
                    </li>
                </ol>
            </div>
            <div>
                <p><u>Czas przetwarzania danych</u></p>
                <ol>
                    <li>
                        <p>
                            Pani/Pana dane osobowe będą przechowywane przez okres od 30 dni do 6 miesięcy, do czasu wykorzystywania możliwości marketingowych.
                        </p>
                    </li>
                </ol>
            </div>
            <div>
                <p><u>Prawa użytkownika strony internetowej</u></p>
                <ol>
                    <li>
                        <p>
                            Posiada Pani/Pan prawo dostępu do treści swoich danych osobowych, prawo do ich sprostowania, usunięcia, jak i również prawo do ograniczenia ich przetwarzania / prawo do cofnięcia zgody, prawo do przenoszenia danych, prawo do wniesienia sprzeciwu wobec przetwarzania Pani/Pana danych osobowych.
                            Przysługuje Pani/Panu prawo wniesienia skargi do organu nadzorczego, jeśli Pani/Pana zdaniem przetwarzanie danych osobowych narusza przepisy unijnego rozporządzenia RODO.
                        </p>
                    </li>
                    <li>
                        <p>
                            Aby skorzystać ze swoich praw skontaktuj się z Administratorem Danych.
                        </p>
                    </li>
                    <li>
                        <p>
                            Pani/Pana dane będą przetwarzane w sposób zautomatyzowany w tym również w formie profilowania. Zautomatyzowane podejmowanie decyzji będzie odbywało się na zasadach stwierdzenia zasadności przesłanego formularza.
                        </p>
                    </li>
                </ol>
            </div>
            <div>
                <h4>Klauzula informacyjna (formularz rejestracyjny)</h4>
                <p>
                    Administratorem Twoich danych osobowych jest Polskie Stowarzyszenie Rodzin z Atrezją Przełyku z siedzibą we Wrocławiu, ul. Piękna 60AB/17, 50-506 NIP: 8993002964, REGON: 529570950. Dane osobowe podane w formularzu będą przetwarzane w celu rejestracji i udziału w konferencji oraz kontaktu organizacyjnego związanego z wydarzeniem, zgodnie z art. 6 ust. 1 lit. b RODO.
                </p>
                <p>
                    Dane mogą być przetwarzane również w celu realizacji obowiązków prawnych Administratora oraz w prawnie uzasadnionym interesie Administratora, jakim jest organizacja wydarzenia. Podanie danych jest dobrowolne, lecz niezbędne do udziału w konferencji.
                </p>
                <p>
                    Przysługuje Ci prawo dostępu do danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia danych, wniesienia sprzeciwu oraz złożenia skargi do Prezesa UODO.
                    Szczegółowe informacje dotyczące przetwarzania danych osobowych znajdują się w Polityce Prywatności dostępnej na stronie internetowej.
                </p>
            </div>
        </>
    );
}

export default RodoPolicy;